import { Form } from "@redriver/cinnamon-mui";
import { resourceTypesLookup } from "modules/lookups";

const ResourceTypeDropdown = (props) => (
  <Form.Dropdown lookup={resourceTypesLookup} {...props} />
);

export default ResourceTypeDropdown;
